import { IconName } from '@cbhq/cds-icons';
import { CoinbaseProfileMenuCommonAction } from '@cbhq/identity-api-hooks/profile-menu/types';

import { MenuActionItem } from '../types';

export function parseActions(action: CoinbaseProfileMenuCommonAction): MenuActionItem {
  const { callbackUrl, key, icon, label, imageUrl, description } = action;
  return {
    callbackUrl: callbackUrl ?? '',
    key: key ?? '',
    icon: icon ? (icon as IconName) : undefined,
    label: label ?? '',
    description,
    imageUrl,
  };
}
